
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2372',
  depVersions: {
  "customer-portal-app": "static-1.2372",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.467",
  "data-fetching-client": "static-1.9685",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25440",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5608",
  "hs-test-utils": "static-1.8031",
  "hub-http": "static-1.6239",
  "hub-http-shared-msw-handlers": "static-1.10012",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18288",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11490",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6481",
  "payment-link-components": "static-1.23599",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7055",
  "quartz-core": "static-1.6274",
  "quartz-i18n": "static-1.730",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10224",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5357",
  "rich-text-lib": "static-1.19866",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18023",
  "ui-components-test-utils": "static-1.5627",
  "UIComponents": "static-3.8436",
  "foundations-assets": "static-1.4885",
  "foundations-components": "static-1.7974",
  "foundations-theming": "static-1.4437",
  "foundations-theming-specialty": "static-1.2153",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.919",
  "quartz-config": "static-1.833",
  "quartz-routing": "static-1.485",
  "quick-fetch": "static-1.3929",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16689",
  "rpc-client-utils": "static-1.4670",
  "sanitize-text": "static-1.8159",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4780",
  "ui-addon-react-router-dom": "static-1.9559",
  "usage-tracker": "static-1.7363",
  "usage-tracker-anonymous": "static-1.5780",
  "usage-tracker-core": "static-1.7213",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3411",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3332",
  "quartz-webpack": "static-1.3279",
  "bend-plugin-quartz-routing": "static-1.133",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7687",
  "frontend-preferences-client": "static-1.7945",
  "laboratory-lib": "static-3.7173",
  "onboarding-scopes": "static-1.6479",
  "seat-types-lib": "static-1.55",
  "ui-addon-opt": "static-4.8383",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3142",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.93",
  "ts-schema": "static-1.4092",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7780",
  "cssUtils": "static-1.797",
  "customer-data-ui-utilities": "static-1.9844",
  "HubStyle": "static-2.11797",
  "knowledge-content-types": "static-1.8488",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9905",
  "ui-addon-i18n": "static-1.11166",
  "ui-business-units-lib": "static-1.9072",
  "ui-shepherd-react": "static-3.10185",
  "video-components-external": "static-1.11339",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4345",
  "commerce-tours-lib": "static-1.6138",
  "customer-data-properties": "static-1.51623",
  "getting-started-shared-tasks": "static-1.18516",
  "growth-onboarding-reliability": "static-1.5100",
  "onboarding-tours": "static-1.16648",
  "reference-resolvers-lite": "static-1.8112",
  "sales-checkout-service-client": "static-1.3658",
  "ui-addon-iframeable": "static-1.9075",
  "user-context": "static-1.5123",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4664",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.730",
  "quartz-head": "static-1.720",
  "quartz-test": "static-1.730",
  "quartz-tracking": "static-1.434",
  "ui-fonts": "static-1.752",
  "usage-tracker-container": "static-1.7353",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9442",
  "data-token-picker": "static-1.16440",
  "FileManagerLib": "static-1.39319",
  "property-translator": "static-1.5417",
  "atom": "static-1.5090",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5938",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5457",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1159",
  "bend-plugin-foundations-components": "static-1.4243",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.1999",
  "bend-plugin-foundations-theming": "static-1.2920",
  "foundations-theming-base": "static-1.3422",
  "stylex": "static-1.33",
  "interframe": "static-3.4777",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5777",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.80",
  "chirp-fetch": "static-1.1905",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4494",
  "react-flip-move": "static-1.70",
  "bender-build-tools": "static-1.3215",
  "inbound-db-properties-service-client": "static-1.3858",
  "superstore": "static-1.4779",
  "feedback-loader": "static-1.29331",
  "ai-components-ui-library": "static-1.9032",
  "ui-addon-video-player": "static-1.8720",
  "ui-coaching-tips": "static-1.28619",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4632",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2515",
  "magpie-lib": "static-1.5562",
  "navigation-messaging": "static-1.7424",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8188",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4669",
  "content-media-composition-data-lib": "static-1.12384",
  "content-media-compositions": "static-2.16391",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4171",
  "magpie-types": "static-1.5022",
  "media-bridge-lib": "static-1.18959",
  "video-data-lib": "static-1.34997",
  "commerce-products-lib": "static-1.9644",
  "crm-message-bus": "static-1.43040",
  "growth-data-modal": "static-1.5457",
  "hubspot-apollo-client": "static-1.4897",
  "onboarding-tours-client": "static-1.4862",
  "calling-global-api": "static-1.64584",
  "calling-internal-common": "static-1.31320",
  "calling-lifecycle-internal": "static-1.65966",
  "calling-lifecycle-messages": "static-1.58260",
  "conditional-properties-service-client": "static-1.3809",
  "crm-links": "static-1.6312",
  "customer-data-objects-ui-components": "static-1.13046",
  "customer-data-properties-shared-msw-handlers": "static-1.9339",
  "customer-data-property-utils": "static-1.8108",
  "external-options-client-types": "static-1.4171",
  "file-manager-components": "static-1.23679",
  "framework-data-schema-resolvers": "static-1.6902",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.171",
  "inbound-db-meta-service-client": "static-1.3598",
  "inbounddb-objects-service-types": "static-1.4235",
  "meetings-icalendar-utils-lib": "static-1.649",
  "multi-currency-client-types": "static-1.3703",
  "object-builder-ui-client": "static-1.48814",
  "pipeline-validation-client-types": "static-1.3977",
  "property-value-citations": "static-1.2237",
  "pulse": "static-1.594",
  "smart-property-lib": "static-1.7180",
  "tiered-pricing": "static-1.1261",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11007",
  "growth-onboarding-confetti": "static-1.3084",
  "growth-onboarding-next-action-utils": "static-1.1980",
  "navigation-components": "static-1.18097",
  "onboarding-tours-utils": "static-1.714",
  "ui-shepherd-tracker": "static-1.7566",
  "ui-universal-auth": "static-1.9000",
  "batch-promise": "static-1.1559",
  "getting-started-shared-tasks-store": "static-1.17634",
  "hubspotter-http-shared-msw-handlers": "static-1.10010",
  "usage-tracker-session-replay": "static-1.5049",
  "audio-components": "static-1.5942",
  "FileManagerCore": "static-1.39178",
  "FileManagerImages": "static-1.36830",
  "video-components": "static-1.13342",
  "foundations-components-legacy": "static-1.999",
  "purchase-motions-api": "static-1.5941",
  "signup-constants": "static-1.18877",
  "signup-ui-url-generator": "static-2.8070",
  "trials-service-types": "static-1.3920",
  "usage-tracker-public": "static-1.7174",
  "chatspot-core": "static-1.21410",
  "ContentUtils": "static-1.68425",
  "copilot-toolkit": "static-1.11185",
  "growth-onboarding-feedback-components": "static-1.6598",
  "reactive-lib": "static-1.741",
  "simple-logging-lib": "static-1.3068",
  "commerce-permissions": "static-1.787",
  "customer-data-tracking": "static-1.6907",
  "products-iframe-lib": "static-1.7994",
  "products-ui-components-shared-msw-handlers": "static-1.10394",
  "restore-request-side-panel-lib": "static-1.933",
  "onboarding-data-sync-lib": "static-1.1986",
  "hubspot-apollo-cache": "static-1.356",
  "calling-error-reporting": "static-1.31327",
  "shared-worker-versioning": "static-1.11054",
  "calling-usage-tracker": "static-1.6559",
  "self-service-api": "static-1.10265",
  "voice-sms-access-library": "static-1.1059",
  "conversations-skeleton-state": "static-1.7264",
  "location-customization-utils-lib": "static-1.9323",
  "crm-pipelines-api-client-types": "static-1.4151",
  "fdsr-migration-layer": "static-1.21",
  "framework-builder-read-service-client": "static-1.4017",
  "framework-data-schema-quick-fetch": "static-1.6807",
  "persist-promise": "static-1.3716",
  "bend-plugin-pulse": "static-1.97",
  "directed-graph": "static-1.953",
  "event-emitter": "static-1.965",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.224",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10095",
  "fsm": "static-1.3748",
  "policy-lib": "static-1.6795",
  "react-tinymce": "static-1.55301",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10158",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54427",
  "tinymce-plugins": "static-1.57541",
  "tinymce-themes": "static-1.56397",
  "growth-onboarding-next-action-components": "static-1.2008",
  "user-context-client": "static-1.4630",
  "nest": "static-1.245",
  "unified-auth-core-lib": "static-1.796",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4554",
  "video-embed": "static-1.35831",
  "content-icons-ui": "static-1.2232",
  "social-insights-client-types": "static-1.22179",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4830",
  "integrations-lib": "static-1.16214",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4276",
  "InboxConnectUtils": "static-4.14871",
  "meetings-connect-utils-lib": "static-1.7623",
  "calling-orchestration-schema": "static-1.35836",
  "crm-record-cards-service-types": "static-1.3609",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4533",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3060",
  "tinymce-data": "static-1.40512",
  "ui-addon-sales-email": "static-1.5228",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12480",
  "layout-dnd-utils": "static-1.11455",
  "react-codemirror": "static-1.10644",
  "ui-brand-identity-lib": "static-1.15365",
  "NamespacedHubStyle": "static-2.9071",
  "outpost": "static-1.4199",
  "flux-actions": "static-1.340",
  "integrations-error-boundary-lib": "static-1.13629",
  "integrations-tracking-lib": "static-1.5619",
  "native-integrations-shared-strings": "static-1.7799",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10383",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.514",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68500",
  "layout-data-lib": "static-1.9780",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3031",
  "google-sheets-integration-lib": "static-1.300",
  "microsoft-drive-integration-lib": "static-1.430",
  "slack-ui-library": "static-1.10410",
  "advanced-menus-core": "static-1.15157",
  "advanced-menus-lib": "static-1.12095",
  "ExportDialog": "static-6.10403",
  "ui-memberships-settings-lib": "static-1.34104",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15156",
  "simple-menus-lib": "static-1.16673"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2372",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.467",
  "data-fetching-client": "/data-fetching-client/static-1.9685",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25440",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5608",
  "hs-test-utils": "/hs-test-utils/static-1.8031",
  "hub-http": "/hub-http/static-1.6239",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10012",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18288",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11490",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6481",
  "payment-link-components": "/payment-link-components/static-1.23599",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7055",
  "quartz-core": "/quartz-core/static-1.6274",
  "quartz-i18n": "/quartz-i18n/static-1.730",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10224",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5357",
  "rich-text-lib": "/rich-text-lib/static-1.19866",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18023",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5627",
  "UIComponents": "/UIComponents/static-3.8436",
  "foundations-assets": "/foundations-assets/static-1.4885",
  "foundations-components": "/foundations-components/static-1.7974",
  "foundations-theming": "/foundations-theming/static-1.4437",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2153",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.919",
  "quartz-config": "/quartz-config/static-1.833",
  "quartz-routing": "/quartz-routing/static-1.485",
  "quick-fetch": "/quick-fetch/static-1.3929",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16689",
  "rpc-client-utils": "/rpc-client-utils/static-1.4670",
  "sanitize-text": "/sanitize-text/static-1.8159",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4780",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9559",
  "usage-tracker": "/usage-tracker/static-1.7363",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5780",
  "usage-tracker-core": "/usage-tracker-core/static-1.7213",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3411",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3332",
  "quartz-webpack": "/quartz-webpack/static-1.3279",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.133",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7687",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7945",
  "laboratory-lib": "/laboratory-lib/static-3.7173",
  "onboarding-scopes": "/onboarding-scopes/static-1.6479",
  "seat-types-lib": "/seat-types-lib/static-1.55",
  "ui-addon-opt": "/ui-addon-opt/static-4.8383",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3142",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.93",
  "ts-schema": "/ts-schema/static-1.4092",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7780",
  "cssUtils": "/cssUtils/static-1.797",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9844",
  "HubStyle": "/HubStyle/static-2.11797",
  "knowledge-content-types": "/knowledge-content-types/static-1.8488",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9905",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11166",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9072",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10185",
  "video-components-external": "/video-components-external/static-1.11339",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4345",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6138",
  "customer-data-properties": "/customer-data-properties/static-1.51623",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18516",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5100",
  "onboarding-tours": "/onboarding-tours/static-1.16648",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8112",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3658",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9075",
  "user-context": "/user-context/static-1.5123",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4664",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.730",
  "quartz-head": "/quartz-head/static-1.720",
  "quartz-test": "/quartz-test/static-1.730",
  "quartz-tracking": "/quartz-tracking/static-1.434",
  "ui-fonts": "/ui-fonts/static-1.752",
  "usage-tracker-container": "/usage-tracker-container/static-1.7353",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9442",
  "data-token-picker": "/data-token-picker/static-1.16440",
  "FileManagerLib": "/FileManagerLib/static-1.39319",
  "property-translator": "/property-translator/static-1.5417",
  "atom": "/atom/static-1.5090",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5938",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5457",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1159",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4243",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.1999",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2920",
  "foundations-theming-base": "/foundations-theming-base/static-1.3422",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4777",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5777",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.80",
  "chirp-fetch": "/chirp-fetch/static-1.1905",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4494",
  "react-flip-move": "/react-flip-move/static-1.70",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3858",
  "superstore": "/superstore/static-1.4779",
  "feedback-loader": "/feedback-loader/static-1.29331",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9032",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8720",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28619",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4632",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2515",
  "magpie-lib": "/magpie-lib/static-1.5562",
  "navigation-messaging": "/navigation-messaging/static-1.7424",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8188",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4669",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12384",
  "content-media-compositions": "/content-media-compositions/static-2.16391",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4171",
  "magpie-types": "/magpie-types/static-1.5022",
  "media-bridge-lib": "/media-bridge-lib/static-1.18959",
  "video-data-lib": "/video-data-lib/static-1.34997",
  "commerce-products-lib": "/commerce-products-lib/static-1.9644",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "growth-data-modal": "/growth-data-modal/static-1.5457",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4897",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4862",
  "calling-global-api": "/calling-global-api/static-1.64584",
  "calling-internal-common": "/calling-internal-common/static-1.31320",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65966",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58260",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3809",
  "crm-links": "/crm-links/static-1.6312",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13046",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9339",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8108",
  "external-options-client-types": "/external-options-client-types/static-1.4171",
  "file-manager-components": "/file-manager-components/static-1.23679",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6902",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.171",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3598",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4235",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.649",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3703",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48814",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3977",
  "property-value-citations": "/property-value-citations/static-1.2237",
  "pulse": "/pulse/static-1.594",
  "smart-property-lib": "/smart-property-lib/static-1.7180",
  "tiered-pricing": "/tiered-pricing/static-1.1261",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11007",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3084",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1980",
  "navigation-components": "/navigation-components/static-1.18097",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.714",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7566",
  "ui-universal-auth": "/ui-universal-auth/static-1.9000",
  "batch-promise": "/batch-promise/static-1.1559",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17634",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10010",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5049",
  "audio-components": "/audio-components/static-1.5942",
  "FileManagerCore": "/FileManagerCore/static-1.39178",
  "FileManagerImages": "/FileManagerImages/static-1.36830",
  "video-components": "/video-components/static-1.13342",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.999",
  "purchase-motions-api": "/purchase-motions-api/static-1.5941",
  "signup-constants": "/signup-constants/static-1.18877",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8070",
  "trials-service-types": "/trials-service-types/static-1.3920",
  "usage-tracker-public": "/usage-tracker-public/static-1.7174",
  "chatspot-core": "/chatspot-core/static-1.21410",
  "ContentUtils": "/ContentUtils/static-1.68425",
  "copilot-toolkit": "/copilot-toolkit/static-1.11185",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6598",
  "reactive-lib": "/reactive-lib/static-1.741",
  "simple-logging-lib": "/simple-logging-lib/static-1.3068",
  "commerce-permissions": "/commerce-permissions/static-1.787",
  "customer-data-tracking": "/customer-data-tracking/static-1.6907",
  "products-iframe-lib": "/products-iframe-lib/static-1.7994",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10394",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.933",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1986",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.356",
  "calling-error-reporting": "/calling-error-reporting/static-1.31327",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11054",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6559",
  "self-service-api": "/self-service-api/static-1.10265",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1059",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7264",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9323",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4151",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.21",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4017",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6807",
  "persist-promise": "/persist-promise/static-1.3716",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.97",
  "directed-graph": "/directed-graph/static-1.953",
  "event-emitter": "/event-emitter/static-1.965",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.224",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10095",
  "fsm": "/fsm/static-1.3748",
  "policy-lib": "/policy-lib/static-1.6795",
  "react-tinymce": "/react-tinymce/static-1.55301",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10158",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54427",
  "tinymce-plugins": "/tinymce-plugins/static-1.57541",
  "tinymce-themes": "/tinymce-themes/static-1.56397",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2008",
  "user-context-client": "/user-context-client/static-1.4630",
  "nest": "/nest/static-1.245",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.796",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4554",
  "video-embed": "/video-embed/static-1.35831",
  "content-icons-ui": "/content-icons-ui/static-1.2232",
  "social-insights-client-types": "/social-insights-client-types/static-1.22179",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4830",
  "integrations-lib": "/integrations-lib/static-1.16214",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4276",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14871",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7623",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35836",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3609",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4533",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3060",
  "tinymce-data": "/tinymce-data/static-1.40512",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5228",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12480",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11455",
  "react-codemirror": "/react-codemirror/static-1.10644",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15365",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9071",
  "outpost": "/outpost/static-1.4199",
  "flux-actions": "/flux-actions/static-1.340",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13629",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5619",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7799",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10383",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.514",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68500",
  "layout-data-lib": "/layout-data-lib/static-1.9780",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3031",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.300",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.430",
  "slack-ui-library": "/slack-ui-library/static-1.10410",
  "advanced-menus-core": "/advanced-menus-core/static-1.15157",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12095",
  "ExportDialog": "/ExportDialog/static-6.10403",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34104",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15156",
  "simple-menus-lib": "/simple-menus-lib/static-1.16673"
}
};
